import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { createTracker } from 'redux-segment';

import api from 'utils/api';
import * as reducers from './reducers';

const IS_PRODUCTION = !!window.location.hostname.match(/^(.*).tewtor.com$/);
const tracker = IS_PRODUCTION ? [createTracker()] : [];

const createReducer = () => combineReducers({
  router: routerReducer,
  ...reducers
});

export default (history, ...middlewares) => {
  const store = createStore(
    createReducer(),
    applyMiddleware(
      thunk.withExtraArgument((...args) => api(store)(...args)),
      routerMiddleware(history),
      ...tracker,
      ...middlewares
    )
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer());
    });
  }

  return store;
};




// WEBPACK FOOTER //
// ./src/configureStore.js